module.exports = __webpack_public_path__ + "img/gb.c39480d5.svg";